import React from "react";

import Head from "next/head";

import { withBrandSuffix } from "@/common/utils/seo-title.utils";
import { CANONICAL_HOST } from "@/config";

const defaultImage = `${CANONICAL_HOST}/icons/icon-512x512.png`;

const SEO = props => {
  const {
    title,
    description,
    image,
    imageAlt,
    children,
    ogType = "website",
    ...other
  } = props;
  /* Strapi titles often already end in "| Whoppah"; never double it (WHO-5543). */
  const documentTitle = withBrandSuffix(title);
  return (
    <Head {...other}>
      {documentTitle ? (
        <>
          <title>{documentTitle}</title>
          <meta property="og:title" content={documentTitle} />
          <meta name="twitter:title" content={documentTitle} />
        </>
      ) : null}
      {description ? (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
          <meta name="twitter:description" content={description} />
        </>
      ) : null}
      <meta property="og:type" content={ogType} />
      <meta name="image" content={image || defaultImage} />
      <meta property="og:image" content={image || defaultImage} />
      <meta name="twitter:image" content={image || defaultImage} />
      {imageAlt ? (
        <>
          <meta property="og:image:alt" content={imageAlt} />
          <meta name="twitter:image:alt" content={imageAlt} />
        </>
      ) : null}
      <meta name="twitter:card" content="summary_large_image" />
      {children}
    </Head>
  );
};

export default SEO;
